import styled from 'styled-components';
import { cssColorValue } from '@spotify-internal/encore-web';
export const GradientEdge = styled.div `
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ toLeft }) => (toLeft ? '-20px' : 'unset')};
  right: ${({ toRight }) => (toRight ? '-20px' : 'unset')};
  width: 80px;
  opacity: 100%;
  background: ${({ toLeft }) => toLeft
    ? `linear-gradient(
    to left,
    rgba(255, 0, 0, 0),
    ${cssColorValue('backgroundBase')},
    ${cssColorValue('backgroundBase')}
  )`
    : `linear-gradient(
    to right,
    rgba(255, 0, 0, 0),
    ${cssColorValue('backgroundBase')},
    ${cssColorValue('backgroundBase')}
  )`};
`;
//# sourceMappingURL=GradientEdge.js.map